import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/base'
import { ServerError } from '@/components/icon'
import { Stack } from '@/components/layout'
import NavigationBar from '@/components/NavigationBar'

function ServerErrorScreen({ onPress, header }: { onPress: () => void; header?: React.ReactElement }) {
  const { t } = useTranslation()
  return (
    <>
      <Stack.Screen
        options={{
          header: () => header || <NavigationBar />
        }}
      />
      <View className={'flex-1 items-center justify-center'}>
        <View className={'items-center gap-4'}>
          <ServerError className={'text-text-quaternary'} />
          <Text className={'text-sm text-text-secondary'}>{t('ui:serverError')}</Text>
          <Button size={'md'} intent={'primary'} variant={'solid'} onPress={() => onPress()}>
            {t('ui:refresh')}
          </Button>
        </View>
      </View>
    </>
  )
}

export default ServerErrorScreen
